/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TerminalCard,
  TerminalCard$inboundSchema,
  TerminalCard$Outbound,
  TerminalCard$outboundSchema,
} from "./terminalcard.js";

/**
 * A card used at point of sale terminal for a card present transaction as contained within a payment method.
 */
export type CardPresentPaymentPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "card-present-payment";
  /**
   * Describes payment card details captured with tap or in-person payment.
   */
  terminalCard?: TerminalCard | undefined;
};

/** @internal */
export const CardPresentPaymentPaymentMethod$inboundSchema: z.ZodType<
  CardPresentPaymentPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("card-present-payment"),
  terminalCard: TerminalCard$inboundSchema.optional(),
});
/** @internal */
export type CardPresentPaymentPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "card-present-payment";
  terminalCard?: TerminalCard$Outbound | undefined;
};

/** @internal */
export const CardPresentPaymentPaymentMethod$outboundSchema: z.ZodType<
  CardPresentPaymentPaymentMethod$Outbound,
  z.ZodTypeDef,
  CardPresentPaymentPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("card-present-payment"),
  terminalCard: TerminalCard$outboundSchema.optional(),
});

export function cardPresentPaymentPaymentMethodToJSON(
  cardPresentPaymentPaymentMethod: CardPresentPaymentPaymentMethod,
): string {
  return JSON.stringify(
    CardPresentPaymentPaymentMethod$outboundSchema.parse(
      cardPresentPaymentPaymentMethod,
    ),
  );
}
export function cardPresentPaymentPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<CardPresentPaymentPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CardPresentPaymentPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CardPresentPaymentPaymentMethod' from JSON`,
  );
}
